





'use strict';






var helpers = {






  skipNav: function (skipNav, language) {
    language = language || 'en';
    var opts = {
      id: "ada-skip-link",
      href: "#skip-to-h1",
      textEn: "Skip to main content",
      textEs: "Ir al contenido principal"
    };


    if (skipNav === false) {
      return;
    }

    if (typeof skipNav === "object") {
      for (var option in skipNav) {
        if (Object.prototype.hasOwnProperty.call(skipNav, option)) {
          opts[option] = skipNav[option];
        }
      }
    }

    return new Handlebars.SafeString("<a class='ada-hidden ada-visible-focus' href='" + opts.href + "' id='" + opts.id + "'>" + (language==='es' ? opts.textEs : opts.textEn) + "</a>");
  }

};


module.exports.register = function (Handlebars, options) {
  options = options || {};
  for (var helper in helpers) {
    if (helpers.hasOwnProperty(helper)) {
      Handlebars.registerHelper(helper, helpers[helper]);
    }
  }
};


module.exports.helpers = helpers;
